import request from '@/utils/request/index'
export default {
	getLabPanelListApi(data) {
		return request.post(
			'/v1/lab/panel/getLabPanelList',
			data
		)
	},
	getLabTypeByPanelId(panelId) {
		return request.post('/v1/front/lab/type/getRootLabTypeList', {
			panelId: panelId
		})
	},
	loadSecondLabType(parentTypeId) {
		return request.post('/v1/front/lab/type/getLabTypeList', {
			parentTypeId: parentTypeId
		})
	},
	submitReportInfo(params) {
		return request.post('/v1/front/lab/report/submitReportInfo', params)
	},
	submitReportInfo2(params) {
		return request.post('/v1/front/lab/report/submitReportInfo2', params)
	},
	//查询报告详情
	getReportInfo(params) {
		return request.post('/v1/front/lab/report/getReportInfo', params)
	},
	//提交更新报告
	submitUpdateReportInfo(params) {
		return request.post('/v1/front/lab/report/submitUpdateReportInfo', params)
	},
	//上传文件
	uploadFile(params) {
		let config = {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		}
		return request.post('/v1/common/upload', params, config)
	},
	updatePwd(params) {
		return request.post('/v1/lab/updatePwd', params)
	},
	updateUser(params) {
		return request.post('/v1/lab/updateUser', params)
	},
	getUserInfo(params) {
		return request.post('/v1/lab/user/getUserInfo', params)
	},
	getReportListForCurrentUser(params) {
		return request.post("/v1/report/getReportListForCurrentUser", params);
	},
	//获取生成pdf报告文件
	getLabReportPdf(params) {
		return request.post('/v1/front/lab/report/getLabReportPdf', params)
	},
	//资源下载请求
	resourceDownload(params) {
		return request.get('/v1/common/download?' + params)
	}
}
